// src/hooks/useUserProfile.ts
import { useContext } from 'react';
import { UserProfileContext, UserProfileContextType } from '../contexts/UserContext'; // Make sure UserProfileContextType is exported

export const useUserProfile = (): UserProfileContextType => {
  const context = useContext(UserProfileContext);
  if (context === undefined) {
    throw new Error('useUserProfile must be used within a UserProfileProvider');
  }
  return context;
};